import { useParams } from 'react-router-dom';
import { REPORT_CATALOG } from '../../config/reportCatalog';
import { CustomReportBuilder } from './CustomReportBuilder';
import '../../css/StandardReportView.css';

interface StandardReportViewProps {
    companyId: string;
    userId: string;
}

/**
 * Standard Report View — resolves a catalog entry by route param
 * and renders CustomReportBuilder pre-configured with catalog defaults.
 * Minimal wrapper that mostly just resolves the catalog entry.
 *
 * Validates: Requirements 14.1, 14.2, 14.3, 14.4, 14.5
 */
export const StandardReportView = ({ companyId, userId }: StandardReportViewProps) => {
    const { reportKey } = useParams<{ reportKey: string }>();

    const catalogEntry = REPORT_CATALOG.find((entry) => entry.key === reportKey);

    if (!catalogEntry) {
        return (
            <div className="page-container standard-report-view">
                <div className="standard-report-view-error">
                    <h3>Report Not Found</h3>
                    <p>The report type "{reportKey}" could not be found in the catalog.</p>
                </div>
            </div>
        );
    }

    return (
        <div className="page-container standard-report-view">
            <CustomReportBuilder
                companyId={companyId}
                userId={userId}
                displayTitle={catalogEntry.displayName}
                backTab="standard"
                defaults={{
                    reportName: catalogEntry.displayName,
                    metricKey: catalogEntry.defaultMetric,
                    groupByField: catalogEntry.defaultGroupBy,
                    visualizationType: catalogEntry.defaultVisualization,
                }}
            />
        </div>
    );
};
